import { ManageCard } from "./ManageCard";
import { METER_TRANSFORMS_ADVANCED_KEY } from "@stores/subscriptions/constants";
import {
  contractedFreeUnits,
  contractedPricePerUnit,
  offeredTransformsType,
  perRunEstimate,
  transformsRunsLineItem,
  transformsUsage,
} from "../utils";
import { IAddOnContext, IMeteredAddOnDescriptor } from "../types";

/** Pay-per-run advanced transforms — the tier sold self-hosted behind the flag. */
const transformsAdvancedMetered = {
  productType: "transforms-advanced-metered",
  kind: "metered",
  title: "Transforms",
  getPricePerUnit: contractedPricePerUnit,
  getIncludedUnits: contractedFreeUnits,

  isVisible: (ctx: IAddOnContext) =>
    !!ctx.subscribed ||
    offeredTransformsType(ctx) === "transforms-advanced-metered",

  getUsage: (ctx: IAddOnContext) =>
    transformsUsage(ctx, METER_TRANSFORMS_ADVANCED_KEY),

  getUpsertAddOns: () => [
    {
      product_type: "transforms-advanced-metered",
      prepaid_units: 1,
    },
  ],

  getEstimateRowItem: (ctx) => ({
    detail: "Advanced: SQL + Python",
    price: perRunEstimate(ctx),
  }),

  getBillingRowItem: () => ({ detail: "Advanced: SQL + Python" }),
  getPurchaseLineItem: transformsRunsLineItem,

  ManageCard,
} satisfies IMeteredAddOnDescriptor;

export default transformsAdvancedMetered;
